import { isValidPhoneNumber, formatPhoneNumber } from 'react-phone-number-input';

const US_PHONE_CODE = 'US';

export const isUsPhoneValid = (value: string): boolean => isValidPhoneNumber(value, US_PHONE_CODE);

export const formatPhone = (value: string | undefined): string =>
    value ? formatPhoneNumber(value) : '';
